import mustache from 'mustache';

/**
 * Timepicker component render's a list of radio inputs as style of calendar date picker.
 */
export default class TimePicker {

  /**
   * Hold all HTML elements used by the component.
   */
  #dom = {};

  /**
   * 
   * @param {HTMLElement} el - The root element of the time picker component.
   */
  constructor( el ) {
    this.#dom.element = el;
  }

  render() {
    const template = `
      {{#times}}
        <span class="time-picker-time">
          <input id="time-{{value}}" type="radio" value="{{value}}" name="{{name}}" {{#checked}}checked{{/checked}}>
          <label class="button-text" for="time-{{value}}">{{value}}</label>          
        </span>
      {{/times}}
    `;

    const html = mustache.render(template, { times: this.selectedTimes, name: this.name });
    this.#dom.element.innerHTML = html;
  }

  get time() {    
    const hiddenInput = document.querySelector(`[data-time-picker="${this.#dom.element.id}"]`);
    return hiddenInput.value;    
  }

  get name() {
    return this.#dom.element.dataset.name ?? 'time[]';
  }

  get selectedTimes() {
    const selectedTime = this.time;

    return ['9-10','10-11','11-12', '12-13', '13-14', '14-15','15-16', '16-17']
      .map(time => {
        return { value: time, checked: time === selectedTime}
      })
  }

  /**
   * Initialize all time picker components on the page.
   */
  static init() { 
    document.querySelectorAll('.time-picker-container').forEach( el => {
      const timePicker = new TimePicker( el );
      timePicker.render();
    });
  }
}